export const SIX_MONTH_CADENCE_OPTION = '6MO_CADENCE';
export const AUTOREFILL_OPTION = 'AUTOREFILL';
export const OTP_OPTION = 'OTP';

export const isCartEmpty = (state) => {
	return Object.keys(state.cart.products).length === 0;
}
